import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { notificationError } from '../../../core/actions';

const TemplatedTextArea = props => {
  const characterCount = () => {
    return (
      <span
        className="fs-12 align-vert-middle h-12"
        style={{ color: setNotif().color, display: 'table-cell', verticalAlign: 'middle' }}
      >
        {props.val.length} characters <FontAwesomeIcon className="m-right-15" icon={setNotif().icon} />
      </span>
    );
    function setNotif() {
      if (props.val.length < 120) {
        return { color: '#86cc4c', icon: ['far', 'check-circle'] };
      }
      if (props.val.length === 120) {
        return { color: '#f7b500', icon: ['far', 'exclamation-circle'] };
      }
      if (props.val.length > 1499) {
        notificationError('Message length exceeds maximum allowed length');
      }
      return { color: '#ff6363', icon: ['far', 'exclamation-triangle'] };
    }
  };

  const buttonStyles = {
    lineHeight: '20px',
    verticalAlign: 'middle',
    border: '1px solid #33aafc',
    borderRadius: '14.5px',
    padding: '3px 9px 2px 9px',
    backgroundColor: 'white',
  };

  const getCursorXY = val => {
    const inp = document.getElementById('textAreaInput');
    const cursorLoc = inp.selectionStart;
    const newString = props.val.substr(0, cursorLoc) + val + props.val.substr(cursorLoc);
    props.changeHandler(newString);
    inp.focus();
  };

  const textHandler = val => {
    props.changeHandler(val);
  };

  return (
    <div className="border-r8-grey max-w-600 w-100-P h-218 pos-rel m-top-15 m-btm-15" style={props.styleProps}>
      <div className="pos-rel height-auto " style={{ minHeight: '120px' }}>
        {/* <ul className="w-100-P  border-none outline-none rem-pad-width h-100-P resize-none fs-12 align-left m-left-0"
                    style={{marginTop: 0, marginBottom: 0, listStyle: 'none', position: 'absolute', left: 0, top: 0, fontFamily: 'Poppins',height: '100px', paddingLeft: 20, paddingTop: '15px', letterSpacing: .5, wordSpacing: 1, whiteSpace: 'pre-wrap', overflow: 'hidden'}}
                >
                    {textFormatter()}
                </ul> */}
        <textarea
          id="textAreaInput"
          value={props.val}
          className="w-100-P transparent border-none outline-none rem-pad-width h-50-P resize-none fs-12 align-left m-left-0 "
          style={{
            // color: 'light-grey',
            // color: 'rgba(0, 0, 0, 0)',
            caretColor: 'black',
            position: 'absolute',
            left: 0,
            width: 'calc(100% - 3px)',
            top: 0,
            fontFamily: 'Poppins',
            height: '100px',
            paddingLeft: 20,
            paddingTop: '15px',
            letterSpacing: 0.5,
            wordSpacing: 1,
            whiteSpace: 'pre-wrap',
            overflow: 'hidden',
          }}
          onChange={e => textHandler(e.target.value)}
          onKeyDown={e => {
            const keyCode = e.key || e.which;
            if (Number(keyCode) === Number(13)) {
              e.preventDefault();
            }
            return false;
          }}
          maxLength="1500"
        />
      </div>
      <div className="align-left pos-abs align-bottom m-btm-12 w-100-P">
        <span className="m-left-15 fs-13">Insert:</span>
        <div className="flex-row-spacebetween-nowrap align-vert-middle w-100-P">
          <div>
            <button
              onClick={() => getCursorXY(':name:')}
              style={buttonStyles}
              className="pointer m-left-10 rem-pad-width blue h-29 fs-13"
            >
              Client Name
            </button>
            <button
              onClick={() => getCursorXY(':review:')}
              style={buttonStyles}
              className="pointer m-left-10 rem-pad-width blue h-29 fs-13"
            >
              Review Link
            </button>
            <button
              onClick={() => getCursorXY(':associate:')}
              style={buttonStyles}
              className="pointer m-left-10 rem-pad-width blue h-29 fs-13"
            >
              Associate Name
            </button>
          </div>
          <div>{characterCount()}</div>
        </div>
      </div>
    </div>
  );
};
export default TemplatedTextArea;
